import { FC } from 'react';
import { ProInput } from '../antd';
import SearchFormItem from './subpage/searchFormItem';
import SearchFormDisabled from './subpage/disabled';
import { getInputPlaceholder } from '../utils/ruleUtils';
import { filterStrSpace } from '../utils/utils';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';
import { NewInputProps } from '../antd/Input/input';
import { formatRender } from './util';

export interface SearchFormInputProps extends BaseSearchFormItemProps {
  /** input Props */
  inputProps?: NewInputProps;
}
/** 文本输入框 */
export const SearchFormInput: FC<SearchFormInputProps> = props => {
  const {
    inputProps,
    render,
    disabledRender,
    isDetail,
    isTable,
    testId,
    rules,
    label,
    name,
    form,
    className,
    copy,
    routeLinkProps,
    ...resProps
  } = props;
  const normFile = (e: any) => {
    const currentValue = e?.target?.value;
    if (currentValue === ' ' || currentValue === undefined) return currentValue;
    return filterStrSpace(currentValue, 'left');
  };

  return (
    <SearchFormItem
      getValueFromEvent={normFile}
      name={name}
      {...resProps}
      disabled={isDetail || inputProps?.disabled}
      label={label}
      rules={rules}
    >
      {isDetail || (inputProps && inputProps.disabled) ? (
        <SearchFormDisabled
          form={form}
          name={name}
          routeLinkProps={routeLinkProps}
          render={formatRender(render, disabledRender)}
          company={resProps.company}
          isTable={isTable}
          copy={copy}
        />
      ) : (
        <ProInput
          placeholder={getInputPlaceholder(label, inputProps, rules)}
          {...inputProps}
          test-id={`${testId}-${name}`}
        />
      )}
    </SearchFormItem>
  );
};

SearchFormInput.displayName = SearchFormItemEnum.SearchFormInput;

export default SearchFormInput;
